import axios from 'axios'
import { SERVER_URL_CATALOGO } from '@/requests/common'
import { setupCommonInterceptors } from '@/axios/CommonsOptions'
import { useNotificationStore } from '@/stores/notification'
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner'

export function createCatalogoAxiosInstance() {
    const axiosInstance = axios.create({
        baseURL: SERVER_URL_CATALOGO,
        headers: {}
    });

    // Inizializza le store Pinia QUI, dove Pinia è garantito essere attivo
    const loadingSpinnerStore = useLoadingSpinnerStore();
    const notificationStore = useNotificationStore();

    // Applica gli interceptor comuni, passando le istanze delle store
    setupCommonInterceptors(axiosInstance, loadingSpinnerStore, notificationStore);

    return axiosInstance;
}
